module.exports = __webpack_public_path__ + "img/nii_logo.d65a15a7.png";